/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import observations from './observations';

import Typography from '../typography';
import Modal from '../modal';
import Button from '../button';

import { useValidationCountry } from '../../utils/validationCountry';

import './deliveryCompaniesObservations.scss';

const DeliveryCompaniesObservations = ({
  isMobileDevice, showButtons, close, next,
  deliveryCompanyImgUrl, deliveryCompanyName, deliveryCompanyId,
  countryCode,
}) => {
  const isCountryValid = useValidationCountry(countryCode);

  return (
    <Modal
      className={`quote-shipping__modal-annotations ${isMobileDevice ? 'mobile-mode' : 'desktop-mode'
      }`}
      closeBackground={() => close && close()}
    >
      <>
        <div className="header__modal-annotations">
          <img
            src={deliveryCompanyImgUrl}
            alt="delivery"
          />
          <Typography
            text={`Observaciones para tener en cuenta de ${deliveryCompanyName}`}
            type="title"
            className="title__header__modal-annotations"
          />
        </div>
        <div className="body__modal-annotations">
          {observations[deliveryCompanyId]}
        </div>
        {showButtons && (
          <div className="footer__modal-annotations">
            <Button
              text="Quiero esta"
              type={isCountryValid ? 'primary-mx' : 'primary'}
              onClick={() => next && next()}
            />
            <Button
              text="Mejor otra"
              type="secondary"
              onClick={() => close && close()}
            />
          </div>
        )}
      </>
    </Modal>
  );
};

DeliveryCompaniesObservations.propTypes = {
  deliveryCompanyImgUrl: PropTypes.string.isRequired,
  deliveryCompanyName: PropTypes.string.isRequired,
  deliveryCompanyId: PropTypes.string.isRequired,
  next: PropTypes.func,
  close: PropTypes.func,
  showButtons: PropTypes.bool,
  isMobileDevice: PropTypes.bool.isRequired,
  countryCode: PropTypes.string.isRequired,
};

DeliveryCompaniesObservations.defaultProps = {
  next: () => null,
  close: () => null,
  showButtons: true,
};

export default (DeliveryCompaniesObservations);
